import { Provider } from '@angular/core';
import { ApplicationSettingsApiService, ReceiptExportFieldSettingsApiService } from '@api';
import { ApplicationSettingsApiMockService } from './application-settings.api-mock.service';
import { ReceiptExportFieldSettingsApiMockService } from './receipt-export-field-settings.api-mock.service';

export const SETTINGS_PROVIDER: Provider[] = [
  { provide: ApplicationSettingsApiService, useClass: ApplicationSettingsApiMockService },
  { provide: ReceiptExportFieldSettingsApiService, useClass: ReceiptExportFieldSettingsApiMockService },
];
